import { useState } from "react";
import { useHistory } from "react-router-dom";
import { login } from "./AuthService";
export function Bejelentkezes() {
  const history = useHistory();
  const [isLoginPending, setLoginPending] = useState(false);

  function loginFormSubmit(e) {
    e.preventDefault();
    setLoginPending(true);
    login(e.target.elements.email.value, e.target.elements.password.value)
      .then(() => {
        setLoginPending(false);
        history.push("/react-kurzus/bejelentkezesi-felulet-epitese?url=/osszes-szallas");
      })
      .catch((err) => {
        alert("Helytelen bejelentkezési adatok, kérjük próbáld újra!");
        setLoginPending(false);
      });
  }

  if (isLoginPending) {
    return (
      <div className="center-item">
        <div className="spinner-border text-danger"></div>
      </div>
    );
  }

  return (
    <div className="container-fluid d-flex justify-content-center h-100 login-container">
      <div className="card login-card">
        <div className="card-header login-card-header">
          <h4>Bejelentkezés</h4>
        </div>
        <div className="card-body">
          <form onSubmit={loginFormSubmit} className="mb-5">
            <div className="input-group form-group">
              <input type="email" name="email" className="form-control" placeholder="Email" />
            </div>
            <div className="input-group form-group">
              <input type="password" name="password" className="form-control" placeholder="Jelszó" />
            </div>
            <div className="form-group">
              <button type="submit" className="btn float-right btn-warning">
                Küldés
              </button>
            </div>
          </form>

          <p className="text-light mb-1">Email: user@kodbazis.hu</p>
          <p className="text-light">Jelszó: teszt</p>
        </div>
      </div>
    </div>
  );
}
